// Main 6 categories for the platform
export const CATEGORIES = [
  'University',
  'NGO', 
  'Schools',
  'Government',
  'Professionals',
  'Companies',
  'Others'
];

// Institution Types - detailed subcategories
export const INSTITUTION_TYPES = [
  'Schools',
  'College',
  'Universities',
  'Government Departments',
  'Ministries',
  'Embassies & High Commissions',
  'NGOs & Foundations',
  'Education Boards',
  'Corporate Partners',
  'Individual Officials (Ambassadors, Education Officers, Directors)',
  'Other'
];

// Legacy permissions (kept for backward compatibility)
export const PERMISSIONS = {
  CREATE_CONTACT: 'create_contact',
  VIEW_CONTACT: 'view_contact',
  EDIT_CONTACT: 'edit_contact',
  DELETE_CONTACT: 'delete_contact',
  CREATE_TEMPLATE: 'create_template',
  VIEW_TEMPLATE: 'view_template',
  EDIT_TEMPLATE: 'edit_template',
  DELETE_TEMPLATE: 'delete_template',
  CREATE_CAMPAIGN: 'create_campaign',
  VIEW_CAMPAIGN: 'view_campaign',
  EDIT_CAMPAIGN: 'edit_campaign',
  DELETE_CAMPAIGN: 'delete_campaign',
  SEND_CAMPAIGN: 'send_campaign',
  CREATE_USER: 'create_user',
  VIEW_USER: 'view_user',
  EDIT_USER: 'edit_user',
  DELETE_USER: 'delete_user'
};
